import { useEffect, useState } from "react";
import "./App.css";
import MapWrapper from "./components/MapWrapper";
import NetworkService from "./NetworkService";
import RideDetails from "./components/RideDetails";
import LoadingScreen from "./components/LoadingScreen";
import { useSearchParams } from "react-router-dom";
import ErrorPage from "./components/ErrorPage";

const MIN_LOADING_MS = 3000;

function App() {
  const [rideDetails, setRideDetails] = useState();
  const [error, setError] = useState(null);
  const [minTimeElapsed, setMinTimeElapsed] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const timer = setTimeout(() => setMinTimeElapsed(true), MIN_LOADING_MS);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const fetchData = (isInitial = false) => {
      if (!error) {
        NetworkService.getRideData(searchParams.get("token"))
          .then((res) => {
            setRideDetails(res);
            setError(null);
            if (isInitial) {
              setInitialLoadComplete(true);
            }
          })
          .catch((err) => {
            setError(err);
            if (isInitial) {
              setInitialLoadComplete(true);
            }
          });
      }
    };

    fetchData(true);
    const interval = setInterval(() => fetchData(false), 8000);

    return () => clearInterval(interval);
  }, [searchParams, error]);

  const isLoading = !minTimeElapsed || !initialLoadComplete;

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="App">
      {!error ? (
        <>
          <MapWrapper rideDetails={rideDetails} />
          <RideDetails rideDetails={rideDetails} />
        </>
      ) : (
        <ErrorPage error={error?.data}>{error?.data?.message}</ErrorPage>
      )}
    </div>
  );
}

export default App;
